const _universalLua = `
-- The following code has been templated from Control4 universal mini drivers

-- Copyright 2020 Wirepath Home Systems, LLC. All Rights Reserved.

JSON = require ('json')

UNIVERSAL_APP_VER = 2
APP_BINDING = 3101
CURRENT_SELECTED_DEVICE = 1000
CURRENT_AUDIO_PATH = 1007

function formatParams(tParams)
	tParams = tParams or {}
	local out = {}
	for k,v in pairs(tParams) do
		table.insert(out, k .. ": " .. tostring(v))
	end
	return table.concat(out, ", ")
end

function OnDriverDestroyed ()
	C4:UnregisterSystemEvent (C4SystemEvents.OnPIP, 0)
end

function OnDriverInit ()
	C4:RegisterSystemEvent (C4SystemEvents.OnPIP, 0)
end

function OnDriverLateInit ()
	local appData = JSON:decode (JSON_APP_DATA)

	if (not (appData and appData.appName and appData.serviceIds)) then
		C4:UpdateProperty ('App Name', 'Error decoding app data')
		return
	end

	C4:AddVariable ('APP_NAME', appData.appName, 'STRING', true, false)

	for source, serviceId in pairs (appData.serviceIds) do
		C4:AddVariable (source, serviceId, 'STRING', true, false)
	end

	C4:UpdateProperty ('App Name', appData.appName)

	RegisterRooms ()
end

function OnSystemEvent (event)
	local eventname = string.match (event, '.-name="(.-)"')
	print("OnSystemEvent: " .. eventname)
	if (eventname == 'OnPIP') then
		ConnectedDevices = (C4:GetBoundConsumerDevices (C4:GetProxyDevices (), APP_BINDING))
		RegisterRooms ()
	end
end

function OnWatchedVariableChanged (idDevice, idVariable, strValue)
	print("OnWatchedVariableChanged[" .. idDevice .. "/" .. idVariable .. "]: " .. strValue)
	if (RoomIDs and RoomIDs [idDevice]) then
		local roomId = tonumber (idDevice)
		if (idVariable == CURRENT_SELECTED_DEVICE) then
			local deviceId = tonumber (strValue) or 0
			RoomIDSources [roomId] = deviceId

		elseif (idVariable == CURRENT_AUDIO_PATH) then
			RoomIDRoutes [roomId] = {}
			for id in string.gmatch (strValue or '', '<id>(.-)</id>') do
				table.insert (RoomIDRoutes [roomId], tonumber (id))
			end
			RoomIDTargets = RoomIDTargets or {}
			RoomIDTargets [roomId] = nil
			ConnectedDevices = ConnectedDevices or (C4:GetBoundConsumerDevices (C4:GetProxyDevices (), APP_BINDING))
			if (ConnectedDevices) then
				for _, id in ipairs (RoomIDRoutes [roomId]) do
					if (ConnectedDevices [id]) then
						RoomIDTargets [roomId] = id
						break
					end
				end
			end
		end
	end
end

function RegisterRooms ()
	print("RegisterRooms() called")
	RoomIDs = C4:GetDevicesByC4iName ('roomdevice.c4i')
	RoomIDSources = {}
	RoomIDRoutes = {}
	for roomId, _ in pairs (RoomIDs) do
		RoomIDSources [roomId] = tonumber (C4:GetDeviceVariable (roomId, CURRENT_SELECTED_DEVICE)) or 0
		RoomIDRoutes [roomId] = {}
		for id in string.gmatch (C4:GetDeviceVariable (roomId, CURRENT_AUDIO_PATH) or '', '<id>(.-)</id>') do
			table.insert (RoomIDRoutes [roomId], tonumber (id))
		end
		C4:UnregisterVariableListener (roomId, CURRENT_SELECTED_DEVICE)
		C4:RegisterVariableListener (roomId, CURRENT_SELECTED_DEVICE)

		C4:UnregisterVariableListener (roomId, CURRENT_AUDIO_PATH)
		C4:RegisterVariableListener (roomId, CURRENT_AUDIO_PATH)
	end
end

function ReceivedFromProxy (idBinding, strCommand, tParams)
	strCommand = strCommand or ''
	tParams = tParams or {}

	print("ReceivedFromProxy[" .. idBinding .. "]: " .. strCommand .. " (" .. formatParams(tParams) .. ")")
	local roomId = tonumber (tParams.ROOMID) or tonumber (tParams.ROOM_ID)

	if (roomId) then
		if (RoomIDTargets [roomId]) then
			tParams.PASSTHROUGH_COMMAND = strCommand
			print("Sending Passthrough[" .. roomId .. "] (" .. formatParams(tParams) .. ")")
			C4:SendToDevice (RoomIDTargets [roomId], 'PASSTHROUGH', tParams)
		end
	end
end

JSON_APP_DATA = [[ENCODED_APP_DATA]]`

const _universalXml = `<devicedata>
<copyright>Copyright 2021 Wirepath Home Systems, LLC. All Rights Reserved.</copyright>
  <manufacturer>Control4</manufacturer>
  <name>[[APP_NAME]] (Universal)</name>
  <model>[[APP_NAME]]</model>
  <creator>Control4</creator>
  <created>02/01/2018 10:45</created>
  <modified>[[DATE_TIME]]</modified>
  <version>[[VERSION]]</version>
  <control>lua_gen</control>
  <replaces>[[LIST_REPLACES]]</replaces>
  <driver>DriverWorks</driver>
  <auto_update>true</auto_update>
  <minimum_auto_update_version>1</minimum_auto_update_version>
  <minimum_os_version>2.9.0</minimum_os_version>
  <small image_source="c4z">icons/device_sm.png</small>
  <large image_source="c4z">icons/device_lg.png</large>
  <config>
      <script file="driver.lua"/>
      <documentation file="www/documentation.html"/>
      <properties>
          <property>
              <name>App Name</name>
              <default></default>
              <type>STRING</type>
              <readonly>true</readonly>
          </property>
      </properties>
      <commands>
      </commands>
  </config>
  <proxies>
      <proxy proxybindingid="5001" name="[[APP_NAME]]" primary="True" image_source="c4z" large_image="icons/device_lg.png" small_image="icons/device_sm.png">media_player</proxy>
  </proxies>
  <capabilities>
      <navigator_display_option proxybindingid="5001">
          <display_icons>
              <Icon height="1024" width="1024">controller://driver/[[FILENAME]]/icons/device/experience_1024.png</Icon>
              <Icon height="512" width="512">controller://driver/[[FILENAME]]/icons/device/experience_512.png</Icon>
              <Icon height="300" width="300">controller://driver/[[FILENAME]]/icons/device/experience_300.png</Icon>
              <Icon height="90" width="90">controller://driver/[[FILENAME]]/icons/device/experience_90.png</Icon>
              <Icon height="70" width="70">controller://driver/[[FILENAME]]/icons/device/experience_70.png</Icon>
          </display_icons>
      </navigator_display_option>
  </capabilities>
  <events>
  </events>
  <connections>
      <connection>
          <id>5001</id>
          <type>2</type>
          <connectionname>MEDIA_PLAYER</connectionname>
          <consumer>False</consumer>
          <linelevel>False</linelevel>
          <classes>
              <class>
                  <classname>MEDIA_PLAYER</classname>
              </class>
          </classes>
      </connection>
      <connection>
          <id>3101</id>
          <type>5</type>
          <connectionname>[[APP_NAME]]</connectionname>
          <consumer>False</consumer>
          <linelevel>False</linelevel>
          <classes>
              <class>
                  <classname>RF_MINI_APP</classname>
              </class>
          </classes>
      </connection>
  </connections>
</devicedata>
`

export const universalXml = _universalXml
export const universalLua = _universalLua

export default {
    universalXml: universalXml,
    universalLua: universalLua
}